import styled from 'styled-components';

const SettingsContainer = styled.div`
  justify-self: flex-end;
  stroke: var(--primary-700);
  cursor: pointer;
  display: flex;
  margin-left: auto;
`;

export default SettingsContainer;
